// extracted by mini-css-extract-plugin
module.exports = {"billingPeriod":"_3JoHgU"};